import {styled} from '@mui/material';
import {CommentIcon} from 'assets/icons';
import {MODE} from 'theme';

export const StyledCommentIcon = styled(CommentIcon)(({theme}) => ({
    path: {
        fill: theme.palette.mode === MODE.LIGHT ? '#977F75' : '#D3D2D2'
    }
}));
